import React from 'react';
import {connect} from "react-redux";
import PaginationButton from "./common/PaginationButton";

const FilterInfoPanel=({filters, data})=>{
    return (<div className='filter-info-container'>
                <div>От: {filters.startDate ? filters.startDate : 'не указано'}</div>
                <div>До: {filters.endDate ? filters.endDate : 'не указано'}</div>
                <div>Продукты: {filters.products.length != 0 ? filters.products.join(", ") : 'не выбраны'}</div>
                <div>Имя пользователя: {filters.username ? filters.username : 'не указано'} Id железа: {(data.devices && data.devices.length != 0) ? data.devices.join(", ") : 'не указан'}</div>
            </div>);
};

const mapStateToProps=(state)=>({filters:state.filters, data: state.data});
const ConnectedFilterInfoPanel=connect(mapStateToProps)(FilterInfoPanel);
export default ConnectedFilterInfoPanel;